<template>
  <div class="search"
       v-show="visible">
    <div class="search-box abs-center">
      <div class="closeBtn"
           @click="close"></div>
      <label class="title">{{language==='en'?'Search':'搜索'}}</label>
      <input class="search-input"
             v-model="keyword" />
      <div class="search-btn"
           @click="search" />
      <div class="search-info">{{resInfo}}</div>
      <input type="checkbox"
             class="check"
             v-model="mode"
             :value="1">
      <div class="check-title">搜索整本杂志</div>
      <div class="search-result-box">
        <div class="search-result-item"
             v-for="item in items"
             :key="item.number"
             @click="gotoPage(item.pageid)">
          <span>{{item.text}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSearch } from '@/api';

export default {
  name: 'searchview',
  props: {
    search_visible: Boolean,
    language: String,
  },
  data() {
    return {
      mode: false,
      keyword: '',
      items: [],
      resInfo: '',
    };
  },
  computed: {
    visible() {
      return this.search_visible;
    },
  },
  methods: {
    close() {
      this.$store.commit('updateView', {
        view: 'book',
      });
    },
    search() {
      console.log(this.keyword);
      if (!this.keyword) {
        this.resInfo = '缺少关键词';
        return;
      }
      getSearch(this.$store.state.code, this.keyword, this.mode).then((res) => {
        this.items = res.items;
        // this.items[0] = { pageid: 22034, text: 'abc', number: 1 };
        // this.items[1] = { pageid: 226740, text: 'abc', number: 2 };
        // this.items[2] = { pageid: 226732, text: 'abc', number: 3 };
        this.resInfo = `搜到${this.items.length}个结果`;
      });
    },
    gotoPage(pageid) {
      this.$store.commit('updateCurrentPageId', {
        currentPageId: pageid,
      });
      this.$store.commit('updateView', {
        view: 'book',
      });
    },
  },
};
</script>
<style lang="less" scoped>
.search {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  z-index: 1000;
  &-box {
    width: 800px;
    height: 480px;
    background: #0b111c;
    border: 10px solid white;
    box-sizing: border-box;
    .title {
      font-size: 24px;
      left: 0px;
      position: absolute;
      color: white;
      margin: 10px 15px;
    }
    .search-input {
      position: absolute;
      width: 300px;
      height: 33px;
      background-color: #505050;
      margin: 55px 15px;
      border: none;
      outline: none;
      left: 0px;
      color: white;
      text-indent: 10px;
    }
    .search-input:focus {
      border: none;
    }
    .search-btn {
      position: absolute;
      margin: 55px 315px;
      width: 35px;
      height: 35px;
      background: url("~@/assets/icon/searchBtn.png");
    }
    .search-info {
      position: absolute;
      line-height: 35px;
      text-align: left;
      width: 200px;
      margin: 55px 380px;
    }
    .search-result-box {
      position: absolute;
      margin-top: 120px;
      height: 300px;
      width: 95%;
      padding: 10px;
      color: white;
      .search-result-item {
        margin: 5px;
        padding: 5px;
        float: left;
        background-color: #505050;
        cursor: pointer;
      }
    }
    .closeBtn {
      width: 31px;
      height: 31px;
      position: absolute;
      right: 0px;
      margin-left: 390px;
      margin-top: 0px;
      background-image: url("~@/assets/icon/imgClose.jpg");
    }
    .check {
      position: absolute;
      margin: 100px 20px;
      left: 0;
    }
    .check-title {
      position: absolute;
      width: 100px;
      left: 0;
      margin: 95px 30px;
    }
  }
}
</style>
